export const JSON_SPLASH = `{
  "name": "Splash",
  "types": [
    {
      "id": 100,
      "supertype": "uievent",
      "name": "Animation Finished"
    },
    {
      "id": 101,
      "supertype": "uievent",
      "name": "ErrorRetryClicked"
    },
    {
      "id": 102,
      "supertype": "uievent",
      "name": "CreatedDirect"
    },
    {
      "id": 103,
      "supertype": "uievent",
      "name": "CreatedFromDeeplink",
      "attributes": [
        {
          "name": "deeplink",
          "type": "String"
        }
      ]
    },
    {
      "id": 104,
      "supertype": "uievent",
      "name": "CreatedFromPush",
      "attributes": [
        {
          "name": "deeplinkTarget",
          "type": "DeepLinkTarget"
        }
      ]
    }
  ],
  "uiComponents": [
    {
      "title": "Logo Intro Animation",
      "spec": "Start immediately  \\nwhen done, fire *100*",
      "events": [
        100
      ]
    },
    {
      "title": "Error",
      "spec": "Error -> show / hide  \\nwith retry - button -> on click -> fire *101*",
      "events": [
        101
      ]
    }
  ],
  "events": [ 102,103,104 ],
  "state": {
    "title": "Splash State",
    "flows": [
      {
        "id": 1,
        "summary": "Verify User Login",
        "requirement": "+ Immediate\\n+ *101*  \\nloggedIn user  \\n  -> exists -> user.id  \\n**1**  \\n  -> API.checkUser  \\n  -> success **2**  \\n  -> error  \\n  -> invalid user -> logoutUser-- > **2**  \\n    -> network error-- > **3**  \\n-> doesn't exist --> **2**",
        "eventsOutput": [
          {
            "id": 1,
            "name": "Loading"
          },
          {
            "id": 2,
            "name": "Done"
          },
          {
            "id": 3,
            "name": "Error",
            "attributes": [
              {
                "name": "Error",
                "type": "ApiError"
              }
            ]
          }
        ]
      },
      {
        "id": 2,
        "summary": "Determine Screen Target",
        "requirement":"LocalStore.wasOnboardingCompleted  \\n  -> completed  \\n  *102*-- > **1**  \\n  *103*  \+ *104*-- > **2**  \\n  -> notCompleted-- > **3**",
        "eventsOutput": [
          {
            "id": 1,
            "name": "MainScreen"
          },
          {
            "id": 2,
            "name": "MainScreen ForDeeplink",
            "attributes": [
              {
                "name": "Deeplink",
                "type": "String"
              }
            ]
          },
          {
            "id": 3,
            "name": "OnboardingScreen"
          }
        ]
      },
      {
        "id": 3,
        "summary": "PrefetchFacebookLink",
        "requirement":"LocalStore.wasOnboardingCompleted  \\n  -> completed-- > **1**  \\n  -> notCompleted -> FB.fetchLink  \\n  \\t\\t\\t&nbsp;&nbsp;&nbsp;&nbsp;-> result  \\n  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-> FBmgr.storeLink  \\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;--> **1**  \\n  &nbsp;&nbsp;&nbsp;&nbsp;-> noResult  \\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;--> **1**",
        "eventsOutput": [
          {
            "id": 1,
            "name": "Ok"
          }
        ]
      },
      {
        "id": 4,
        "summary": "Proceed",
        "requirement":"wait and combine  \\n  *100*  \\n    - ***1.2***  \\n    - ***3.1***  \\n    - ***2.0***  \\n**1**",
        "eventsOutput": [
          {
            "id": 1,
            "name": "Screen to go to"
          }
        ]
      }
    ],
    "stateChangers": [
      {
        "eventSource": {
          "type": "flow",
          "id": "1.1"
        },
        "changeTargets": 
        [
          {
            "type": "attribute",
            "id": "1"
          }
        ],
        "changes": "Clear **1**"
      },
      {
        "eventSource": {
          "type": "flow",
          "id": "1.3"
        },
        "changeTargets": 
        [
          {
            "type": "attribute",
            "id": "1"
          }
        ],
        "changes": "error -> **1**"
      },
      {
        "eventSource": {
          "type": "flow",
          "id": "4.1"
        },
        "changeTargets": 
        [
          {
            "type": "action",
            "id": "1"
          },
          {
            "type": "action",
            "id": "2"
          },
          {
            "type": "action",
            "id": "3"
          }
        ],
        "changes": "passed target screen  \\nonboarding-- > ***3***  \\nmain-- > ***1***  \\nmain with deeplink-- > ***2***"
      }
    ],
    "attributes": [
      {
        "id": 1,
        "name": "Error",
        "type": "ApiError"
      }
    ],
    "actions": [
      {
        "id": 1,
        "name": "Launch Main Screen"
      },
      {
        "id": 2,
        "name": "Launch Main Screen From Deeplink",
        "type": "DeepLinkTarget"
      },
      {
        "id": 3,
        "name": "Launch Onboarding"
      }
    ]
  }
}`;



// WEBPACK FOOTER //
// ./src/components/splash.js